import { type UseQueryResult, useQuery } from 'react-query';
import { TradePreClearanceTransactionPeriodConfigurationService } from '../../services/wealthlane-award-settlement-services';

const useGetTransactionPeriodTypes = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const transactionPeriodTypes = useQuery(
    ['getTransactionPeriodTypes'],
    async () => {
      return await handleRequest(
        TradePreClearanceTransactionPeriodConfigurationService.getApiAwardSettlementApiAppTradePreClearanceTransactionPeriodConfigurationTransactionPeriodTypes()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return transactionPeriodTypes;
};

export default useGetTransactionPeriodTypes;
